
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/liked/shops",
      function () {
        return require("private-next-pages/liked/shops.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/liked/shops"])
      });
    }
  